module.exports = __webpack_public_path__ + "img/transparent-back.bafa4f90.png";